import { useState } from "react";
import { agencies } from "@/mocks/agencies";

export default function MapSection() {
  const [selected, setSelected] = useState(agencies[0].id);

  const selectedAgency = agencies.find((a) => a.id === selected)!;

  return (
    <section id="mapa" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest">Localização</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-1">Agências em Campinas e Região</h2>
          <p className="text-gray-500 mt-2">Encontre a agência mais próxima de você</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 rounded-2xl overflow-hidden border border-gray-100">
          {/* Agency List */}
          <div className="w-full lg:w-[380px] flex-shrink-0 bg-gray-50 p-4 flex flex-col gap-3 max-h-[520px] overflow-y-auto">
            {agencies.map((agency) => (
              <button
                key={agency.id}
                onClick={() => setSelected(agency.id)}
                className={`text-left p-4 rounded-xl border transition-all cursor-pointer ${
                  selected === agency.id
                    ? "bg-white border-orange-400 shadow-sm"
                    : "bg-white border-gray-100 hover:border-orange-200"
                }`}
              >
                <div className="flex items-start gap-3">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-full flex-shrink-0 ${
                    selected === agency.id ? "bg-orange-500" : "bg-gray-100"
                  }`}>
                    <i className={`ri-map-pin-2-fill text-sm ${selected === agency.id ? "text-white" : "text-gray-500"}`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-gray-900 text-sm leading-tight">{agency.name}</h4>
                    <p className="text-gray-500 text-xs mt-0.5 leading-relaxed">{agency.address}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-xs text-green-600 font-medium flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-car-line text-xs"></i>
                        </div>
                        {agency.vehicles} veículos
                      </span>
                      <span className="text-xs text-gray-400 flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-walk-line text-xs"></i>
                        </div>
                        {agency.distance}
                      </span>
                    </div>
                  </div>
                </div>
                {selected === agency.id && (
                  <div className="mt-3 pt-3 border-t border-gray-100">
                    <p className="text-xs text-gray-500 flex items-center gap-1 mb-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-time-line text-xs"></i>
                      </div>
                      {agency.hours}
                    </p>
                    <p className="text-xs text-gray-500 flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-phone-line text-xs"></i>
                      </div>
                      {agency.phone}
                    </p>
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${selectedAgency.lat},${selectedAgency.lng}`}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="mt-3 flex items-center justify-center gap-2 bg-orange-500 text-white text-xs font-bold px-4 py-2 rounded-lg cursor-pointer whitespace-nowrap"
                    >
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-navigation-line text-xs"></i>
                      </div>
                      Ver Rota
                    </a>
                  </div>
                )}
              </button>
            ))}
          </div>

          {/* Map */}
          <div className="flex-1 min-h-[400px] lg:min-h-[520px]">
            <iframe
              title="Mapa de Agências LocaCar - Campinas"
              width="100%"
              height="100%"
              style={{ minHeight: "400px", border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU3Luo&q=${encodeURIComponent(selectedAgency.address)}&zoom=14`}
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
